import { API_URL } from "@/utils/api/config";
import { useEffect, useRef } from "react";
import { connect } from "socket.io-client";
import { SocketType, ServerToClientEvents } from "./socket-hook";

export type OnServerToClientEvents = {
	[K in keyof ServerToClientEvents as `on${Capitalize<K>}`]?: (
		...args: Parameters<ServerToClientEvents[K]>
	) => void;
};

export type UseSocketProps = {
	accessToken: string;
	onConnect?: (...args: any) => any;
	onConnectError?: (...args: any) => any;
	onDisconnect?: (...args: any) => any;
} & OnServerToClientEvents;

export const useSocket = ({
	accessToken,
	onConnect,
	onConnectError,
	onDisconnect,
	onUserStatusUpdate,
}: UseSocketProps) => {
	const socketRef = useRef<SocketType | null>(null);
	useEffect(() => {
		const socket: SocketType = connect(API_URL, {
			extraHeaders: { Authorization: `Bearer ${accessToken}` },
			reconnection: true,
			reconnectionAttempts: 5,
		});
		socketRef.current = socket;

		onConnect && socket.on("connect", onConnect);
		onConnectError && socket.on("connect_error", onConnectError);
		onDisconnect && socket.on("disconnect", onDisconnect);
		onUserStatusUpdate && socket.on("userStatusUpdate", onUserStatusUpdate);

		return () => {
			socket.close();
		};
	}, [accessToken]);

	return { socket: socketRef.current };
};
